import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { sortAndFilterCards } from '../boards.helpers';

export default function useStatusCards(statusId) {
  const { type: sortType, field: sortField } = useSelector((state) => state.boards.sortType);

  const selectedBoard = useSelector((state) => state.boards.selectedBoard);
  const boards = useSelector((state) => state.boards.boards);
  const cardIds = useSelector((state) => state.boards.statusToCardIdMap[statusId]);
  const shadowIds = useSelector((state) => state.boards.statusToShadowIdMap[statusId]);
  const allCards = useSelector((state) => state.boards.fullCards);
  const filters = useSelector((state) => state.boards.filters);
  const projects = useSelector((state) => state.projects.projects);
  const filteredCardIds = useSelector(
    (state) => state.boards.filteredCardIds?.[selectedBoard?.id] ?? null,
  );

  const cardArray = useMemo(() => (
    cardIds
      ?.map((cardId) => allCards[cardId])
      ?.filter((card) => !!card) ?? []
  ), [cardIds, allCards]);

  const cards = useMemo(() => (
    sortAndFilterCards({
      cards: cardArray,
      sortType,
      filters,
      field: sortField,
      projects,
      board: selectedBoard ? boards[selectedBoard.id] : {},
      filteredCardIds,
    })
  ), [
    cardArray,
    sortType,
    filters,
    sortField,
    projects,
    selectedBoard,
    boards,
    filteredCardIds,
  ]);

  const shadowArray = useMemo(() => (
    shadowIds
      ?.map((cardId) => allCards[cardId])
      ?.filter((card) => !!card) ?? []
  ), [shadowIds, allCards]);

  const shadows = useMemo(() => (
    sortAndFilterCards({
      cards: shadowArray,
      sortType,
      filters,
      field: sortField,
      projects,
      board: selectedBoard ? boards[selectedBoard.id] : {},
      filteredCardIds,
    })
  ), [
    shadowArray,
    sortType,
    filters,
    sortField,
    projects,
    selectedBoard,
    boards,
    filteredCardIds,
  ]);

  return {
    cardIds,
    cards,
    shadowIds,
    shadows,
  };
}
